import { render, staticRenderFns } from "./InspectionCriteria6.vue?vue&type=template&id=f9331c98&scoped=true"
import script from "./InspectionCriteria6.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria6.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria6.vue?vue&type=style&index=0&id=f9331c98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9331c98",
  null
  
)

export default component.exports